import { Slide } from '@/components/core/Slide';
import tokensImage from './tokens.png';

export const slide = () => {
  return (
    <Slide notes="Explanation of how ChatGPT works" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">Hoe werkt ChatGPT</h2>

        <div className="space-y-4">
          <p>• Denkt in tokens, opgehakte woorden</p>
          <p>• Begrijpt concepten op basis van patroonherkenning en statistiek</p>
          <p>• Voorspelt welke tokens volgen zonder echt begrip</p>
          <p>• Op basis van een rol als AI assistent en de context van een gesprek</p>
          <p>• Heeft geen geheugen, het hele gesprek dient als invoer</p>
          <p>
            • Heeft toegang tot externe tools als Vision, Web Browsing, Dall-E en Code Interpreter
          </p>
        </div>

        <div className="mt-8">
          <img src={tokensImage} alt="Example of token splitting" className="max-w-3xl" />
        </div>
      </div>
    </Slide>
  );
};
